<script>
import SLSUsuarioRepresentanteService from '@/services/SistemaDKP/SLSUsuarioRepresentante.service';
import { mapGetters } from 'vuex';
import { BOverlay } from 'bootstrap-vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

const usuarioRepresentanteService = new SLSUsuarioRepresentanteService();
export default {
  name: 'UsuarioRepresentante',
  components: { BOverlay },
  props: ['value'],
  data() {
    return {
      isLoading: false,
      codigoRepresentanteNaoSelecionado: null,
      nomeRepresentanteNaoSelecionado: null,
      codigoRepresentanteSelecionado: null,
      nomeRepresentanteSelecionado: null,
      isSelectedAllNaoSelecionado: false,
      isSelectedAllSelecionado: false,
      selectedRepresentanteSelecionado: [],
      selectedRepresentanteNaoSelecionado: [],
      columnsSelecionados: [
        {
          label: '#',
          key: 'selected',
        },
        {
          label: 'Código Representante',
          key: 'representanteid',
        },
        {
          label: 'Representante',
          key: 'representantenome',
        },
        {
          label: 'Ações',
          key: 'acoes',
        },
      ],
      columnsNaoSelecioando: [
        {
          label: '#',
          key: 'selected',
        },
        {
          label: 'Código Representante',
          key: 'representanteid',
        },
        {
          label: 'Representante',
          key: 'representantenome',
        },
        {
          label: 'Açõe',
          key: 'acoes',
        },
      ],
    };
  },
  watch: {
    value: {
      async handler(newValue) {
        if (typeof newValue.usuarioid !== 'undefined' && newValue.usuarioid !== null) {
          await this.listarRepresentanteSlecioandoENapSelecionado(newValue);
        }
      },
      immediate: true, // Chama buscarPerfils imediatamente após a montagem do componente
    },
  },
  computed: {
    ...mapGetters('SLSUsuarioRepresentante', {
      filtersNapSelecionado: 'getFiltersNaoSelecionado',
      filtersSelecionados: 'getFiltersSelecionado',
      representantesNaoSelecionados: 'getRepresentantesNaoSelecionados',
      representantesSelecionados: 'getRepresentantesSelecionados',
    }),
    dataMetaNaoSelecionado() {
      const localCount = this.representantesNaoSelecionados.length;
      const meta = {
        page: this.filtersNapSelecionado.perPage * (this.filtersNapSelecionado.page - 1) + (localCount ? 1 : 0),
        perPage: this.filtersNapSelecionado.perPage * (this.filtersNapSelecionado.page - 1) + localCount,
        total: this.filtersNapSelecionado.total,
      };
      if (meta.page && meta.perPage && meta.total) {
        return `Mostrando ${meta.page} de ${meta.perPage} entradas de ${meta.total} entradas`;
      }
      return 'Mostrando 0 até 0 entradas de 0 entradas';
    },
    dataMetaSelecionado() {
      const localCount = this.representantesSelecionados.length;
      const meta = {
        page: this.filtersSelecionados.perPage * (this.filtersSelecionados.page - 1) + (localCount ? 1 : 0),
        perPage: this.filtersSelecionados.perPage * (this.filtersSelecionados.page - 1) + localCount,
        total: this.filtersSelecionados.total,
      };
      if (meta.page && meta.perPage && meta.total) {
        return `Mostrando ${meta.page} de ${meta.perPage} entradas de ${meta.total} entradas`;
      }
      return 'Mostrando 0 até 0 entradas de 0 entradas';
    },
    dataUsuario: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    resertVariaveisGerais() {
      this.isSelectedAllNaoSelecionado = false;
      this.selectedRepresentanteSelecionado = [];
      // this.$refs.refTableSelecionados.clearSelected()
      this.isSelectedAllSelecionado = false;
      this.selectedRepresentanteNaoSelecionado = [];
      // this.$refs.refTableNaoSelecionado.clearSelected()
    },
    // INICIO -> USUARIO x REPRESENTANTE
    async buscarRepresentanteNaoSelecionado() {
      try {
        this.isLoading = true;
        this.$store.commit('SLSUsuarioRepresentante/setCodigoNaoSelecionado', this.codigoRepresentanteNaoSelecionado);
        this.$store.commit('SLSUsuarioRepresentante/setRepresentanteNomeNaoSelecionado', this.nomeRepresentanteNaoSelecionado);
        this.$store.commit('SLSUsuarioRepresentante/setPageNaoSelecionado', 1);
        await usuarioRepresentanteService.listarRepresentantesNaoSelecionados({
          ...this.filtersNapSelecionado,
          usuarioId: this.dataUsuario.usuarioid,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    limparBuscarRepresentanteNaoSelecionado() {
      this.codigoRepresentanteNaoSelecionado = null;
      this.nomeRepresentanteNaoSelecionado = null;
      this.$store.commit('SLSUsuarioRepresentante/setCodigoNaoSelecionado', null);
      this.$store.commit('SLSUsuarioRepresentante/setRepresentanteNomeNaoSelecionado', null);
      this.$store.commit('SLSUsuarioRepresentante/setPageNaoSelecionado', 1);
      this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async buscarRepresentanteSelecionado() {
      try {
        this.isLoading = true;
        this.$store.commit('SLSUsuarioRepresentante/setCodigoSelecionado', this.codigoRepresentanteSelecionado);
        this.$store.commit('SLSUsuarioRepresentante/setRepresentanteNomeSelecionado', this.nomeRepresentanteSelecionado);
        await usuarioRepresentanteService.listarRepresentantesSelecionados({
          ...this.filtersSelecionados,
          usuarioId: this.dataUsuario.usuarioid,
          page: 1,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    limparBuscarRepresentanteSelecionado() {
      this.codigoRepresentanteSelecionado = null;
      this.nomeRepresentanteSelecionado = null;
      this.$store.commit('SLSUsuarioRepresentante/setCodigoSelecionado', null);
      this.$store.commit('SLSUsuarioRepresentante/setRepresentanteNomeSelecionado', null);
      this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async adicionarTodosRepresentantes() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Adicionando todos...',
          icon: 'LoaderIcon',
          variant: 'success',
        },
      });
      await usuarioRepresentanteService.adicionarTodosRepresentantes(this.dataUsuario.usuarioid);
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async adicionarRepresentante(repsentante) {
      await usuarioRepresentanteService.create({
        usuarioid: this.dataUsuario.usuarioid,
        representanteid: repsentante.representanteid,
      });
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async removerRepresentante(repsentante) {
      await usuarioRepresentanteService.destroy(this.dataUsuario.usuarioid, repsentante.representanteid);
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async removerTodosRepresentante() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Removendo todos...',
          icon: 'LoaderIcon',
          variant: 'success',
        },
      });
      await usuarioRepresentanteService.removerTodosRepresentantes(this.dataUsuario.usuarioid);
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async removerSelecionadpRepresentanteSelecionado() {
      await usuarioRepresentanteService.removerSelecionadpRepresentanteSelecionado({
        usuarioId: this.dataUsuario.usuarioid,
        representanteIds: this.selectedRepresentanteSelecionado.map((item) => item.representanteid),
      });
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async adicionarSelecionadoRepresentanteNaoSelecionado() {
      await usuarioRepresentanteService.adicionarSelecionadoRepresentanteNaoSelecionado({
        usuarioId: this.dataUsuario.usuarioid,
        representanteIds: this.selectedRepresentanteNaoSelecionado.map((item) => item.representanteid),
      });
      await this.listarRepresentanteSlecioandoENapSelecionado(this.dataUsuario);
    },
    async listarRepresentanteSlecioandoENapSelecionado(newValue) {
      this.$store.commit('SLSUsuarioRepresentante/setLoading', true);
      await usuarioRepresentanteService.listarRepresentantesNaoSelecionados({
        ...this.filtersNapSelecionado,
        usuarioId: newValue.usuarioid,
      });
      await usuarioRepresentanteService.listarRepresentantesSelecionados({
        ...this.filtersSelecionados,
        usuarioId: newValue.usuarioid,
      });
      this.resertVariaveisGerais();
      this.$store.commit('SLSUsuarioRepresentante/setLoading', false);
    },
    async onChanePaginationRepresetanteNaoSelecionado(event) {
      try {
        this.$store.commit('SLSUsuarioRepresentante/setLoading', true);
        await usuarioRepresentanteService.listarRepresentantesNaoSelecionados({
          ...this.filtersNapSelecionado,
          usuarioId: this.dataUsuario.usuarioid,
          page: event,
          perPage: 8,
          representanteid: this.codigoRepresentanteSelecionado,
          representantenome: this.nomeRepresentanteNaoSelecionado,
        });
        this.$store.commit('SLSUsuarioRepresentante/setPageNaoSelecionado', event);
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.commit('SLSUsuarioRepresentante/setLoading', false);
      }
    },
    async onChanePaginationRepresetanteSelecionados(event) {
      try {
        this.$store.commit('SLSUsuarioRepresentante/setLoading', true);
        await usuarioRepresentanteService.listarRepresentantesSelecionados({
          ...this.filtersSelecionado,
          usuarioId: this.dataUsuario.usuarioid,
          page: event,
          perPage: 8,
          representanteid: this.codigoRepresentanteSelecionado,
          representantenome: this.nomeRepresentanteNaoSelecionado,
        });
        this.$store.commit('SLSUsuarioRepresentante/setPageNaoSelecionado', event);
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.commit('SLSUsuarioRepresentante/setLoading', false);
      }
    },
    async onRowSelectedRepSelecionado(item) {
      this.selectedRepresentanteSelecionado = item;
    },
    selectAllRepresentanteSelecionado(selected) {
      if (selected.allSelected) {
        this.isSelectedAllNaoSelecionado = true;
        this.$refs.refTableSelecionados.selectAllRows();
      } else {
        this.isSelectedAllNaoSelecionado = false;
        this.$refs.refTableSelecionados.clearSelected();
      }
    },
    async onRowSelectedRepNaoSelecionado(item) {
      this.selectedRepresentanteNaoSelecionado = item;
    },
    selectAllRepresentanteNaoSelecionado(selected) {
      if (selected.allSelected) {
        this.isSelectedAllSelecionado = true;
        this.$refs.refTableNaoSelecionado.selectAllRows();
      } else {
        this.isSelectedAllSelecionado = false;
        this.$refs.refTableNaoSelecionado.clearSelected();
      }
    },
    // FIM -> USUARIO x REPRESENTANTE
  },
};
</script>

<template>
  <b-overlay
      variant="white"
      :show="isLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
  >
    <b-row>
      <b-col cols="12" md="6">
        <div class="mb-3">
          <h5 class="mb-3 text-primary font-weight-bold">
            <feather-icon icon="UsersIcon" size="20" class="mr-1"/>
            Representantes Disponíveis
          </h5>
        </div>
        <b-row class="align-items-center">
          <b-col cols="12" md="4" class="mb-2 mb-md-0">
            <b-form-group
                label="Código"
                label-for="basicInput"
            >
              <b-form-input
                  id="basicInput"
                  placeholder="Código"
                  v-model="codigoRepresentanteNaoSelecionado"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" class="mb-2 mb-md-0">
            <b-form-group
                label="Nome"
                label-for="basicInput"
            >
              <b-form-input
                  id="basicInput"
                  placeholder="Nome"
                  v-model="nomeRepresentanteNaoSelecionado"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" md="auto" class="mb-2 mb-md-0">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                class="btn-icon w-100 d-md-inline-block"
                @click="buscarRepresentanteNaoSelecionado"
            >
              <feather-icon icon="SearchIcon" class="d-md-none"/>
              <span class="d-none d-md-inline"><feather-icon icon="SearchIcon"/></span>
              <span class="d-md-none ml-1">Buscar</span>
            </b-button>
          </b-col>
          <b-col cols="6" md="auto" class="mb-2 mb-md-0">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="btn-icon w-100 d-md-inline-block"
                @click="limparBuscarRepresentanteNaoSelecionado"
            >
              <feather-icon icon="TrashIcon" class="d-md-none"/>
              <span class="d-none d-md-inline"><feather-icon icon="TrashIcon"/></span>
              <span class="d-md-none ml-1">Limpar</span>
            </b-button>
          </b-col>
          <b-col
              cols="12"
              class="mb-3"
          >
            <div class="d-flex flex-column flex-md-row" style="gap: 10px; align-items: stretch;">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon flex-fill flex-md-grow-0"
                  @click="adicionarTodosRepresentantes"
                >
                  <!-- :disabled="representantesNaoSelecionados.length === 0" -->
                Adicionar Todos
              </b-button>
              <b-button
                  v-if="selectedRepresentanteNaoSelecionado.length > 0"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-success"
                  class="btn-icon flex-fill flex-md-grow-0"
                  @click="adicionarSelecionadoRepresentanteNaoSelecionado"
              >
                Adicionar Selecionados
              </b-button>
              <span
                  v-if="selectedRepresentanteNaoSelecionado.length > 0"
                  class="font-weight-bolder text-center text-md-left mt-2 mt-md-0"
              >{{ selectedRepresentanteNaoSelecionado.length }} selecionados</span>
            </div>
          </b-col>
          <b-col cols="12" class="mb-3">
            <b-table
                responsive="sm"
                ref="refTableNaoSelecionado"
                :fields="columnsNaoSelecioando"
                :items="$store.getters['SLSUsuarioRepresentante/getRepresentantesNaoSelecionados']"
                selectable
                select-mode="multi"
                show-empty
                empty-text="Nenhum registro encontrado"
                @row-selected="onRowSelectedRepNaoSelecionado"
                :busy="$store.getters['SLSUsuarioRepresentante/getLoading']"
                class="mobile-table"
            >
              <template #table-busy>
                  <div class="text-center my-2">
                      <b-spinner class="align-middle" variant="primary"></b-spinner>
                      <strong class="ml-2">Carregando...</strong>
                  </div>
              </template>
              <template v-slot:head(selected)="data">
                <b-form-checkbox
                    id="selecionarTodos-nao-selecionados"
                    v-model="data.allSelected"
                    @change="selectAllRepresentanteNaoSelecionado(data)"
                >
                </b-form-checkbox>
                <b-tooltip
                    target="selecionarTodos-nao-selecionados"
                    title="Marcar todos"
                    variant="secondary"
                >
                </b-tooltip>
              </template>
              <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <b-form-checkbox
                      v-model="rowSelected"
                      disabled
                  >
                  </b-form-checkbox>
                </template>
                <template v-else>
                  <b-form-checkbox
                      v-model="rowSelected"
                      disabled
                  >
                  </b-form-checkbox>
                </template>
              </template>
              <template v-slot:cell(acoes)="props">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="gradient-success"
                    class="btn-icon"
                    @click="adicionarRepresentante(props.item)"
                >
                  <feather-icon icon="PlusIcon"/>
                </b-button>
              </template>
            </b-table>
          </b-col>
          <b-col
              cols="12"
              v-if="!$store.getters['SLSUsuarioRepresentante/getLoading']"
          >
            <div v-if="representantesNaoSelecionados.length === 0" class="text-center">
                    <span class="font-weight-bold">
                      Todos os representantes foram selecionados
                    </span>
            </div>
            <div v-else class="d-flex justify-content-between flex-wrap mb-1">
              <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap ">
                      {{ dataMetaNaoSelecionado }}
                    </span>
              </div>
              <div>
                <b-pagination
                    v-model="filtersNapSelecionado.page"
                    :total-rows="filtersNapSelecionado.total"
                    :per-page="filtersNapSelecionado.perPage"
                    first-number
                    @change="onChanePaginationRepresetanteNaoSelecionado"
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="6">
        <div class="mb-3">
          <h5 class="mb-3 text-success font-weight-bold">
            <feather-icon icon="BriefcaseIcon" size="20" class="mr-1"/>
            Representantes Na Sua Carteira
          </h5>
        </div>
        <b-row class="align-items-center">
          <b-col cols="12">
            <b-row>
              <b-col cols="12" md="3" class="mb-2 mb-md-0">
                <b-form-group
                    label="Código"
                    label-for="basicInput"
                >
                  <b-form-input
                      id="basicInput"
                      placeholder="Código"
                      v-model="codigoRepresentanteSelecionado"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" class="mb-2 mb-md-0">
                <b-form-group
                    label="Nome"
                    label-for="basicInput"
                >
                  <b-form-input
                      id="basicInput"
                      placeholder="Nome"
                      v-model="nomeRepresentanteSelecionado"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="2" align-self="center" class="mb-2 mb-md-0">
                <div class="d-flex d-md-block justify-content-center" style="gap: 10px">

                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      class="btn-icon flex-fill flex-md-grow-0"
                      @click="buscarRepresentanteSelecionado"
                  >
                    <feather-icon icon="SearchIcon" class="d-md-none"/>
                    <span class="d-none d-md-inline"><feather-icon icon="SearchIcon"/></span>
                    <span class="d-md-none ml-1">Buscar</span>
                  </b-button>
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="danger"
                      class="btn-icon flex-fill flex-md-grow-0"
                      @click="limparBuscarRepresentanteSelecionado"
                  >
                    <feather-icon icon="TrashIcon" class="d-md-none"/>
                    <span class="d-none d-md-inline"><feather-icon icon="TrashIcon"/></span>
                    <span class="d-md-none ml-1">Limpar</span>
                  </b-button>
                </div>

              </b-col>
            </b-row>
          </b-col>
          <b-col
              cols="12"
              class="mb-3"
          >
            <div class="d-flex flex-column flex-md-row" style="gap: 10px; align-items: stretch;">
              <b-button
                  :disabled="representantesSelecionados.length === 0"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon flex-fill flex-md-grow-0"
                  @click="removerTodosRepresentante"
              >
                Remover Todos
              </b-button>
              <b-button
                  v-if="selectedRepresentanteSelecionado.length > 0"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-danger"
                  class="btn-icon flex-fill flex-md-grow-0"
                  @click="removerSelecionadpRepresentanteSelecionado"
              >
                Remover Selecionados
              </b-button>
              <span
                  v-if="selectedRepresentanteSelecionado.length > 0"
                  class="font-weight-bolder text-center text-md-left mt-2 mt-md-0"
              >{{ selectedRepresentanteSelecionado.length }} selecionados</span>
            </div>
          </b-col>
          <b-col cols="12" class="mb-3">
            <b-table
                responsive="sm"
                :fields="columnsSelecionados"
                :items="representantesSelecionados"
                ref="refTableSelecionados"
                selectable
                select-mode="multi"
                show-empty
                empty-text="Nenhum registro encontrado"
                @row-selected="onRowSelectedRepSelecionado"
                :busy="$store.getters['SLSUsuarioRepresentante/getLoading']"
                class="mobile-table"
            >
              <template #table-busy>
                  <div class="text-center my-2">
                      <b-spinner class="align-middle" variant="primary"></b-spinner>
                      <strong class="ml-2">Carregando...</strong>
                  </div>
              </template>
              <template v-slot:head(selected)="data">
                <b-form-checkbox
                    id="selecionarTodos-selecionados"
                    v-model="data.allSelected"
                    @change="selectAllRepresentanteSelecionado(data)"
                >
                </b-form-checkbox>
                <b-tooltip
                    target="selecionarTodos-selecionados"
                    title="Marcar todos"
                    variant="secondary"
                >
                </b-tooltip>
              </template>
              <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <b-form-checkbox
                      v-model="rowSelected"
                      disabled
                  >
                  </b-form-checkbox>
                </template>
                <template v-else>
                  <b-form-checkbox
                      v-model="rowSelected"
                      disabled
                  >
                  </b-form-checkbox>
                </template>
              </template>
              <template v-slot:cell(acoes)="props">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="gradient-danger"
                    class="btn-icon"
                    @click="removerRepresentante(props.item)"
                >
                  <feather-icon icon="MinusIcon"/>
                </b-button>
              </template>
            </b-table>
          </b-col>
          <b-col
              cols="12"
              v-if="!$store.getters['SLSUsuarioRepresentante/getLoading']"
          >
            <div v-if="representantesSelecionados.length === 0" class="text-center">
                    <span class="font-weight-bold">
                      Nenhum representante selecionado
                    </span>
            </div>
            <div v-else class="d-flex justify-content-between flex-wrap mb-1">
              <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap ">
                      {{ dataMetaSelecionado }}
                    </span>
              </div>
              <div>
                <b-pagination
                    v-model="filtersSelecionados.page"
                    :total-rows="filtersSelecionados.total"
                    :per-page="filtersSelecionados.perPage"
                    first-number
                    @change="onChanePaginationRepresetanteSelecionados"
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<style scoped>
@media (max-width: 767.98px) {
  .mobile-table {
    font-size: 0.875rem;
  }

  .mobile-table .btn-icon {
    padding: 0.25rem 0.5rem;
    min-height: 44px;
  }

  .b-table-selectable tbody tr:hover {
    background-color: rgba(0, 123, 255, 0.1);
  }

  .btn-icon {
    min-height: 44px;
    touch-action: manipulation;
  }

  .b-pagination {
    justify-content: center;
  }

  .b-pagination .page-link {
    min-height: 44px;
    min-width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
